import { useApiClient } from "@myplant-io/utils/api";
import { useQuery } from "react-query";
import { ConversationSearchResult } from "../types";

export function useConversationSearch(
  query: string,
  maxLength?: number
) {
  const client = useApiClient();
  const params = new URLSearchParams({ q: query });
  if (maxLength !== undefined) {
    params.set("max_length", String(maxLength));
  }
  return useQuery<ConversationSearchResult[]>(
    ["conversation", "search", query, maxLength],
    () =>
      client.fetch(
        `/api/history/conversation/search?${params.toString()}`
      ),
    {
      enabled: query.length > 0,
      keepPreviousData: true,
    }
  );
}
